if(typeof BSS_B2B != undefined) {
  if(window.location.pathname.includes("/account/register")){
    (() => {
      const interval = setInterval(() => {
        //fix password
        let rfField = $("#create_customer:has(.password-field) #bss-b2b-registration-form-render")
         let passwordField = $(".password-field");
        let labelPassword = $("[for='register_password']");
        let inputPassword = $("#register_password");
        if (rfField.length && passwordField.length && labelPassword.length && inputPassword.length) {
          clearInterval(interval);
          if(rfField && passwordField) {
              passwordField.after(rfField);
          }
          if(labelPassword && inputPassword) {
            inputPassword.after(labelPassword)
          }
    
          //handle form rf 
          $("#site-main .form-group:not(.field-country-field, .field-accepts-marketing)").each(function (ind, item) {
            $(item).addClass("form-field form-field--half");
            const input = $(item).find("input");
            const label = $(item).find("label");
            if (input) {
              $("input").attr("placeholder", " ");
            }
            if (input && label) {
              input.addClass("form-field-input form-field-text");
              label.addClass("form-field-title");
              input.after(label);
            }
          });
    
          //handle text-area
          const area = document.querySelector(".formbuilder-textarea textarea");
          const label = document.querySelector(".formbuilder-textarea label");
      
          area.addEventListener("focus", (event) => {
            label.classList.add("handle-transition");
          });
      
          area.addEventListener("blur", (event) => {
            if (event.target.value === "") {
              label.classList.remove("handle-transition");
            }
          });
        }
      }, 200);
      setTimeout(() => {
        clearInterval(interval);
      }, 20000)
    })();
  }

  if(window.location.pathname.includes("/cart")) {
    setTimeout(() =>{
      let dcBox = $(".bss-b2b-discount-code-wrapper.bss-config-header");
      let cartOrderNote = $(".cart-ordernote");
      if(dcBox && cartOrderNote) {
          cartOrderNote.after(dcBox);
      }
    }, 200)
    
  }

  if(window.location.pathname.includes("/products/")) {
    let loop = setInterval(() =>{
      const styleVat = $("#bss-b2b-tax-inc-excl");
      if(styleVat.length) {
        clearInterval(loop)
        styleVat.remove();
      }
    }, 500);

    setTimeout(() =>{
      clearInterval(loop)
    }, 7000)
  }
  
}
